import type { IAdminAuthService } from "@src/domain/interfaces";
import type { AdminUser } from "@src/domain/entities";

export abstract class AdminAuthService implements IAdminAuthService {
    abstract login(forceRefresh?: boolean): Promise<AdminUser | null>;
    abstract logout(): Promise<void>;
    abstract refreshPermissions(): Promise<AdminUser | null>;
    abstract getUser(): AdminUser | null;
    abstract isLoading(): boolean;
    abstract getAccessToken(): Promise<string | null>;
    abstract getRefreshToken(): Promise<string | null>;
}